export default {
  login: 'login',
  services: 'services',
  equipes: 'equipes'
};
